import React, { useEffect } from 'react';
import styles from '../Wyszukiwarka.module.css';
import { useZamowienia } from 'hooks/useZamowienia';


  export default function DataSpedycji({dataSpedycji, setDataSpedycji} ){

            const { globalSearch } = useZamowienia();
    
            useEffect(() => {
          globalSearch();
        
      }, [dataSpedycji]);
  return(
      <div className={styles.colData_nr}>
      <label className={styles.labelData}> Spedycja </label>
      <input className={styles.inputData} style={{width:"130px"}} type="month"
            value={dataSpedycji}
            onChange={(event) => {
  
              setDataSpedycji(event.target.value);
              
            }}></input>
    </div>
  );
}